import { extractValidationErrors, fromJSONAPI, toJSONAPI } from './serializer';

export class JSONAPINetworkCall {
  constructor(method, resource, data) {
    this.method = method;
    this.resource = resource;
    this.data = data;
  }

  url() {
    return `${process.env.REACT_APP_FATSOMA_API_URL}/${this.resource}`;
  }

  headers() {
    return new Headers({
      'Content-Type': 'application/vnd.api+json',
      'X-Api-Key': process.env.REACT_APP_FATSOMA_API_KEY,
    });
  }

  body() {
    if (this.data) {
      return JSON.stringify(toJSONAPI({ type: this.resource, ...this.data }));
    }
  }
}

const responseValidationErrors = (body, requestData) => {
  let respErrors = {};

  const errors = extractValidationErrors(body);
  Object.keys(errors).forEach(key => {
    respErrors[key] = { ...errors[key], value: requestData[key] };
  });

  return respErrors;
};

export const callJSONAPI = networkCall => {
  return fetch(networkCall.url(), {
    method: networkCall.method,
    headers: networkCall.headers(),
    body: networkCall.body(),
  }).then(res => {
    return new Promise((resolve, reject) => {
      res.json().then(body => {
        if (res.ok) {
          resolve(fromJSONAPI(body));
        } else {
          reject({
            status: res.status,
            json: body,
            validationErrors: responseValidationErrors(body, networkCall.data),
          });
        }
      });
    });
  });
};



// WEBPACK FOOTER //
// ./src/utils/jsonapi/network.js